<template lang="pug">
  div(class='container')
    h3 Manage Featured Listings
    ul
      li(v-for='listing in featuredListingsIds' :class='getClass(listing.id)')
        h4 {{ getDescription(listing.id) }}
        span {{listing.id}}
        a(@click='remove(listing.id)') &#10006;
    input(v-model='newId')
    a(@click='add') Add By ID
</template>

<script>
import {getFeaturedListingsIds, removeFeaturedListing, addFeaturedListing, getFeaturedListings } from '../api/listings'
import {mapState} from 'vuex'

export default {
  data(){
    return{
      featuredListingsIds: [],
      featuredListings: [],
      newId: ""
    }
  },

  computed: {
    ...mapState(["admin"])
  },

  methods: {
    async remove(id){
      const returnId = await removeFeaturedListing(id);
      this.featuredListingsIds = this.featuredListingsIds.filter(listing => listing.id != returnId);
    },

    async add(){
      try{
        const id = this.newId;
        const newFeaturedListingId = await addFeaturedListing(id);
        this.featuredListingsIds.push(newFeaturedListingId);
        this.featuredListings = await getFeaturedListings();
      }
      catch(e){
        alert(e);
      }
    },

    getDescription(id){
      const listing = this.featuredListings.filter(listing => listing.ID == id)[0];
      //const statusString = (listing && listing.Status != "ONMARKET") ? ` (${listing.Status})` : "";
      return (listing) ? `${listing.StreetNumber} ${listing.StreetName} ${listing.Unit}` : "Unknown Listing";
    },

    getClass(id){
      const listing = this.featuredListings.filter(listing => listing.ID == id)[0];
      return (listing) ? listing.Status : "UNKNOWN";
    }

  },

  async mounted(){
    if (!this.admin) this.$router.replace('/home');
    const [featuredListingsIds, featuredListings] = await Promise.all([
      getFeaturedListingsIds(),
      getFeaturedListings(),
    ]);
    this.featuredListingsIds = featuredListingsIds;
    this.featuredListings = featuredListings;

    //this.featuredListingsIds = await getFeaturedListingsIds();
    //this.featuredListings = await getFeaturedListings();
  }
}
</script>

<style lang="scss" scoped>
.container{
  min-height: 400px;
  
}

li a{
  color: mix(white, $color-primary, 70);
  padding: 1px 4px;
  margin-left: 5px;
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 0;
  background-color: transparent;
}

li a:hover{
  color: orange;
}

a{
  background-color: green;
  padding: 7px 9px;
  margin-left: 5px;
  cursor: pointer;
} 

ul{
  max-width: 300px;
  margin: 15px auto;
}

h3{
  font-size: 1.5em;
  font-weight: normal;
  cursor: pointer;
  padding: 10px;
  padding-left: 40px;
  padding-right: 40px;
  margin: 10px;
  background-color: #2a365d;
  display: inline-block;
  border-radius: 2px;
  color: white;
}

h4{
  margin: 0;
  color: $color-primary;
}

li{
  padding: 8px 15px;
  background-color:#f0f0f0;
  margin-top: 5px;
  color: $color-primary-dark-40;
  position: relative;
  text-align: left;
  border-left: 10px solid $color-primary;
  transition: all .25s;
}

li:hover{
  background-color:#fdfdfd;
  border-left-width: 20px !important;
}

li.OFFMARKET{
  border-left: 10px solid darkred;
}

li.APP{
  border-left: 10px solid darkorange;
}

li.UNKNOWN{
  border-left: 10px solid rgb(235, 214, 27);
}

input{
  min-height: 30px;
  min-width: 200px;
}
</style>